<template>
  <header class="main_header flx" id="main_header">
    <div class="menu flx">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
      >
        <g fill="#FFF" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
          />
        </g>
      </svg>
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="18"
        height="15"
        viewBox="0 0 18 15"
        class="icon"
        @click="sideBar()"
      >
        <defs>
          <path
            id="a"
            d="M1.336 0h15.328a1.336 1.336 0 0 1 0 2.671H1.336a1.336 1.336 0 0 1 0-2.671zm0 6.164h15.328a1.336 1.336 0 0 1 0 2.672H1.336a1.336 1.336 0 0 1 0-2.672zm0 6.165h15.328a1.336 1.336 0 0 1 0 2.671H1.336a1.336 1.336 0 1 1 0-2.671z"
          />
        </defs>
        <use fill="#FFF" fill-rule="evenodd" xlink:href="#a" />
      </svg>-->
      <h1>Shopping Mall</h1>
    </div>
    <div class="action flx">
      <router-link :to="{ path: '/live-show'}" replace>
        <span class="badge1">
          <span class="badge_text" v-if="dataLiveShow">LIVE</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            class="tvIcon"
          >
            <g
              fill="none"
              fill-rule="evenodd"
              stroke="#FFF"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              transform="translate(1 1)"
            >
              <rect width="20" height="15" y="5" rx="2" />
              <path d="M15 0l-5 5-5-5" />
            </g>
          </svg>
        </span>
      </router-link>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
        <path
          fill="#FFF"
          fill-rule="evenodd"
          d="M17.2 13.202v-5a6 6 0 1 0-12 0v5c0 .729-.195 1.412-.535 2h13.07a3.983 3.983 0 0 1-.535-2zm4 4h-20c-1.333 0-1.333-2 0-2a2 2 0 0 0 2-2v-5a8 8 0 1 1 16 0v5a2 2 0 0 0 2 2c1.333 0 1.333 2 0 2zm-7.405 3.503a3 3 0 0 1-5.19 0 1 1 0 0 1 .865-1.502h3.46a1 1 0 0 1 .865 1.502z"
        />
      </svg>-->
    </div>
    <div class="search_bar flx">
      <span
        @click="goToSearchResult(searchTerm)"
        style="display: block; width: 84%; height: 40px; left: 0;"
      >
        <img src="../../assets/images/search.svg" alt="search" />
        <span>Search here ...</span>
      </span>
      <i
        class="material-icons"
        @click="isAi()"
        style="position:absolute; right:10px; background:#fff; color:#999"
      >mic</i>
    </div>
  </header>
</template>
<script>
import AI from "../../views/AI";
export default {
  name: "MainHeader",
  props: {
    dataLiveShow:{
      type: Boolean
    }
  },
  components: {
    AI
  },
  data() {
    return {
      searchTerm: "",
      openAIPage: false,
      // isLiveShow: false
    };
  },
  methods: {
    isAi() {
      this.$emit("AiCheck", true);
    },
    closeAiPage() {
      this.openAIPage = false;
    },
    sideBar() {
      this.$emit("sideBar");
    },
    goBack() {
      // if (this.$cookie.get("version-code") > 57) {
      //   if (window.history.length == 1) {
      //     try {
      //       JSBridgePlugin.gotToHome();
      //     } catch (err) {
      //       console.log(err);
      //     }
      //   } else {
      //     this.$router.go(-1);
      //   }
      // } else {
      //   this.$router.go(-1);
      // }
       try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
    },
    goToSearchResult(prodName) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/search");
    },
  },
};
</script>